module.exports = __webpack_public_path__ + "static/media/ic-instant-book-color-copy-4.ad3a27ca.svg";